import { Component, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControl, DISABLED } from '@angular/forms/src/model';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { UploadService } from '../../uploads/shared/upload.service';
import { Upload } from '../../uploads/shared/upload';
import { LocationService } from '../../services/locations/location.service';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as _ from 'underscore';

function mapSnapshot(changes: any) {
	return changes.map(a => {
		const data = a.payload.doc.data() as User;
		const id = a.payload.doc.id;
		return { id, ...data };
	});
}

@Component({
	selector: 'app-setting',
	templateUrl: './setting.component.html',
	styleUrls: ['./setting.component.scss'],
	providers: [WindowService]
})
export class SettingComponent implements OnInit {
	public lastError: string = null;
	public lastErrorPhone: string = null;

	public selectedInstitution: object;

	public sentPhoneValidation: boolean = false;
	windowRef: any;

	private logoFileURL = "";
	public countries: any[];

	private imageFileURL = "";
	imgURL = "../../assets/img/no-image.png";

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private upSvc: UploadService, private fb: FormBuilder, private spinnerService: Ng4LoadingSpinnerService, private locationService: LocationService, public router: Router, public route: ActivatedRoute) { }

	ngOnInit() {
		this.getUserDetails();
		this.createSettingForm();
		this.getCountries();
	}

	settingForm: FormGroup;

	selectedFiles: FileList;
	currentUpload: Upload;
	private basePath: string = '/uploads';
	uploads: Observable<Upload[]>;

	getUserDetails(){
		let objUser = firebase.auth().currentUser;
		const userRef = this.afs.collection('users').doc(objUser.uid);
		userRef.valueChanges().subscribe(user => {
			//Get user hospital
			const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
				? user['adminFor'][0].id : '';
			this.selectedInstitution = { id: user['adminFor'][0].id };
			//get hospital info
			const hospRef = this.afs.collection('institutions').doc(userHospId);
			hospRef.valueChanges().subscribe(hosp => {
				console.log(hosp);
				if (hosp['logo'] !== "") {
					this.imgURL = hosp['logo'];
					this.imageFileURL = hosp['logo'];
				}

				this.settingForm.patchValue({
					hospname: hosp['name'],
					address: hosp['address'],
					state: hosp['state'],
					zipcode: hosp['zipcode'],
					city: hosp['city'],
					phone: hosp['phone'],
					email: user['email'],
					first_name: user['first_name'],
					last_name: user['last_name']
				});
			});




			
		});
		
	}

	isFieldValid(field) {
		return !this.settingForm.get(field).valid && (this.settingForm.get(field).dirty || this.settingForm.get(field).touched);
	}

	getCountries(): void {
		this.locationService.getCountries()
			.subscribe(x => {
				//console.log(x);
				this.countries = x;
			});
	}

	createSettingForm() {
		this.settingForm = this.fb.group({
			hospname: ['', Validators.required],
			country: ['231', Validators.required],
			state: ['', Validators.required],
			city: ['', Validators.required],
			address: ['', Validators.required],
			zipcode: [''],
			phone: ['', [
				Validators.minLength(10),
				Validators.maxLength(10),
				Validators.pattern("[0-9]*")
			]],
			first_name: ['', Validators.required],
			last_name: ['', Validators.required],
			email: ['']
		})
	}

	detectFiles(event) {
		this.selectedFiles = event.target.files;
		this.uploadLogo();
	}

	pushUploadLogo(upload: Upload) {
		let storageRef = firebase.storage().ref();
		let filename = Math.random().toString(36).split('').filter(function (value, index, self) {
			return self.indexOf(value) === index;
		}).join('').substr(2, 12);
		let uploadTask = storageRef.child(this.basePath + "/" + filename + upload.file.name).put(upload.file);
		uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
			(snapshot) => {
				// upload in progress
				upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100
			},
			(error) => {
				// upload failed
				console.log(error)
			},
			() => {
				// upload success
				upload.url = uploadTask.snapshot.downloadURL
				upload.name = upload.file.name
				this.upSvc.saveFileData(upload);
				this.imageFileURL = upload.url;
				this.imgURL = upload.url;
			}
		);
	}

	uploadLogo() {
		let file = this.selectedFiles.item(0);
		this.currentUpload = new Upload(file);
		this.pushUploadLogo(this.currentUpload);
	}

	deleteLogo() {
		let file = this.selectedFiles.item(0);
		this.currentUpload = new Upload(file);
		this.upSvc.deleteUpload(this.currentUpload);
		this.imgURL = "";
	}

	clickCancel() {
		this.router.navigate(['/home']);
	}

	saveSetting(){
		this.lastError = null;
		let user = firebase.auth().currentUser;
		var objUser = this.settingForm.value;
		var error = "";
		var self = this;
		if (objUser.hospname == "") {
			this.isFieldValid('hospname');
		}
		if (objUser.first_name == "") {
			this.isFieldValid('first_name');
		}
		if (objUser.last_name == "") {
			this.isFieldValid('last_name');
		}
		if (objUser.phone == "") {
			this.isFieldValid('npi_number');
		}
		if (objUser.address == "") {
			this.isFieldValid('phone');
		}
		if (objUser.city == "") {
			this.isFieldValid('invite_code');
		}
		if (objUser.state == "") {
			this.isFieldValid('state');
		}
		if (objUser.country == "") {
			this.isFieldValid('country');
		}
		if (objUser.zipcode == "") {
			this.isFieldValid('zipcode');
		}
		if (error == "") {
			if (self.settingForm.value) {
				self.spinnerService.show();
				var hid = this.selectedInstitution['id'];
				const hospDoc = this.afs.doc('institutions/' + hid);
				self.afs.collection('users').doc(user.uid).update({
					first_name: objUser.first_name,
					last_name: objUser.last_name,
					phone: objUser.phone,
					modified: firebase.firestore.FieldValue.serverTimestamp()
				}).then(function (res) {
					self.afs.collection('institutions').doc(hid).update({
						locations: [
							{
								name: objUser.hospname,
								ref: ""
							}
						],
						logo: self.imageFileURL,
						name: objUser.hospname,
						address: objUser.address,
						country: objUser.country,
						state: objUser.state,
						zipcode: objUser.zipcode,
						city: objUser.city,
						phone: objUser.phone
					});
					
					self.spinnerService.hide();
					self.router.navigate(['/home']);
					return Promise.resolve();
				});
			}

		}else{

		}
	}

}



// WEBPACK FOOTER //
// ./src/app/modules/setting/setting.component.ts